module.exports = __webpack_public_path__ + "static/media/phone icon.37bfb339.svg";